export default __webpack_public_path__ + "static/media/family-studies-circle.7b2a57b9.jpg";